export default {"src":"/_next/static/media/ContainerBackGround.70e623dd.svg","height":543,"width":1684,"blurWidth":0,"blurHeight":0};